import { useContext } from 'react';

import type { PetitionMitaAlternateImageData } from 'src/app/pages/petitionGamma/details/shared/types';

import { MitaContext } from './context';

export function useMitaPhoto(): PetitionMitaAlternateImageData | undefined {
	return useContext(MitaContext);
}
